import LegalLayout, { Section, LEGAL_CONTACT } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="TERMS OF USE."
      intro={`These terms govern your use of the ${LEGAL_CONTACT.brand} website and your purchases from us. By browsing, buying or creating an account, you agree to them.`}
    >
      <Section title="Who we are">
        <p>
          {LEGAL_CONTACT.brand} is a proprietary firm of {LEGAL_CONTACT.entity}, a business registered in India
          (GSTIN: {LEGAL_CONTACT.gst}) and licensed under the Food Safety and Standards Act (FSSAI licence: {LEGAL_CONTACT.fssai}).
          All payments for orders on this website are collected by {LEGAL_CONTACT.entity}; your bank or card statement will reflect {LEGAL_CONTACT.entity}.
        </p>
        <p>Registered office: {LEGAL_CONTACT.address}.</p>
        <p>References to "we", "us" and "our" mean {LEGAL_CONTACT.brand} / {LEGAL_CONTACT.entity}.</p>
      </Section>

      <Section title="Using this site">
        <p>You agree to use this site only for lawful purposes, to provide accurate information at checkout, and to keep your account credentials confidential. We may suspend accounts used for fraud, abuse or reselling attempts that breach these terms.</p>
        <p>Content on this site — text, packaging imagery, mascot characters and design — belongs to us and may not be copied for commercial use without written permission.</p>
      </Section>

      <Section title="Products and food information">
        <p>
          Our products are single-ingredient kitchen powders sold as food. They are not medicines, supplements or treatments,
          and nothing on this site is medical advice. If you are pregnant, nursing, on medication or managing a health condition,
          please consult your doctor before adding anything new to your diet — including our powders.
        </p>
        <p>Always check the pouch for ingredients and allergen information. Packaging may be updated from time to time; the physical pouch governs.</p>
      </Section>

      <Section title="Pricing and payments">
        <p>All prices are in Indian Rupees (INR) — the final selling price, inclusive of applicable taxes. Shipping is ₹49 flat and free on orders of ₹499 and above, unless a live promotion states otherwise.</p>
        <p>We accept payments through Razorpay (UPI, cards, netbanking, wallets) and Cash on Delivery / UPI on confirmation. We do not store your card or UPI credentials — payments are processed by Razorpay, a PCI-DSS compliant gateway.</p>
      </Section>

      <Section title="Order acceptance">
        <p>Your order is an offer to buy. We accept it when we confirm it (by call, WhatsApp or email). In the rare case of a pricing error or stock issue, we will inform you and refund in full.</p>
      </Section>

      <Section title="Promotions and coupons">
        <p>Coupons such as FIRSTPOWDER or SHIPFREE, and automatic bundle savings, apply on the terms displayed at checkout. They cannot be exchanged for cash, and we may withdraw a promotion at any time. A coupon may be cancelled if it was obtained through abuse.</p>
      </Section>

      <Section title="Intellectual property">
        <p>Our mascot characters (including Mr. Onio, Turmy, Mr. Ringa and the rest of the squad), brand name, packaging and website design are our intellectual property. Do not reproduce them without permission.</p>
      </Section>

      <Section title="Limitation of liability">
        <p>To the extent permitted by law, our liability for any claim relating to an order is limited to the amount you paid for that order. We are not liable for indirect or consequential losses.</p>
        <p>Nothing in these terms limits your statutory rights as a consumer under Indian law.</p>
      </Section>

      <Section title="Governing law">
        <p>These terms are governed by the laws of India. Any disputes are subject to the exclusive jurisdiction of the courts of Maharashtra, India.</p>
      </Section>

      <Section title="Grievance officer">
        <p>Under the Consumer Protection (E-Commerce) Rules, 2020, our Grievance Officer can be reached at {LEGAL_CONTACT.email} or {LEGAL_CONTACT.phone}. We respond within 48 hours and resolve complaints within one month.</p>
      </Section>
    </LegalLayout>
  );
}
